import D2C_HostCloud from './Cloud'
import D2C_HostAWS from './AWS'
import D2C_HostDO from './DO'
import D2C_HostGCP from './GCP'
import D2C_HostUpcloud from './Upcloud'
import D2C_HostVultr from './Vultr'
import D2C_HostCustom from './Custom'

export default {
  HostCloud: D2C_HostCloud,
  HostAWS: D2C_HostAWS,
  HostDO: D2C_HostDO,
  HostGCP: D2C_HostGCP,
  HostUpcloud: D2C_HostUpcloud,
  HostVultr: D2C_HostVultr,
  HostCustom: D2C_HostCustom,
}
